import React from 'react'
import { Navigate, useLocation } from "react-router-dom";

import {
  getLoginToken,
} from '@/utils/localStorage';
import { checkTokenIsValid, getPageQuery } from '@/utils/utils';
import useEntryPath from '@/hooks/useEntryPath';

const RouteGuard = (props) => {
  const location = useLocation();
  const { getEntryPath } = useEntryPath();
  const { entryPath } = useEntryPath();

  const { pathname, search } = location;
  // 拿到子组件,router的参数
  const { children, role } = props

  const loginRoute = {
    robot: getEntryPath() || '/robot/login',
  }

  // console.log('****ROLE***', role)

  // 获取token，校验token是否有效，路由是否需要拦截
  const token = getLoginToken(role);
  const isTokenValid = checkTokenIsValid(token);
  // console.log('****isTokenValid***', isTokenValid)
  if (!isTokenValid) {
    return <Navigate to={loginRoute[role]} state={{ from: `${pathname}${search}` }} replace={true}></Navigate>
  }

  return <>{children}</>
}
export default RouteGuard
